import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
// import NudityPicOne from "../../../../assets/images/nudity1.png";
import { useSelector } from "react-redux";

const ViewVideo = ({
  showModal,
  closeModal,
  selectedItem,
  getLangTranslation = () => {},
}) => {
  const { ID: parentID } = useSelector(({ auth }) => auth.user);

  const modalRef = useRef();

  useEffect(() => {
    // console.log(selectedItem);
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation("VIDEO", "Video")}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className=" ratio ratio-5x3 mb-3">
              <video
                className="rounded-3 pt-cursor"
                src={selectedItem}
                controls
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVideo;
